// === AGENCE INK GSAP LIBRARY === // 

/**
 * @copyright Copyright (c) Agence ink
 * Code by Mathieu V.
 */

// ==== [DOCUMENTATION] => https://www.notion.so/webink/GSAP-Library-2fe9ae09221349fabddce4b65adffe2a

////////////////////////// GSAP animation modules importation ////////////////////////////////
import gsap from "gsap";                                                                    //
import ScrollTrigger from "gsap/ScrollTrigger"; gsap.registerPlugin(ScrollTrigger);         //
import ScrollSmoother from "gsap/ScrollSmoother"; gsap.registerPlugin(ScrollSmoother);      //
import ScrollToPlugin from "gsap/ScrollToPlugin"; gsap.registerPlugin(ScrollToPlugin);      //
import DrawSVGPlugin from "gsap/DrawSVGPlugin"; gsap.registerPlugin(DrawSVGPlugin);         //
import MorphSVGPlugin from "gsap/MorphSVGPlugin"; gsap.registerPlugin(MorphSVGPlugin);      //
import SplitText from "gsap/SplitText"; gsap.registerPlugin(SplitText);                     //
//////////////////////////////////////////////////////////////////////////////////////////////

export const gsapLib = () => {

    // DOWN
    let downElements = document.querySelectorAll('[data-gsap="down"]');
    if (downElements.length) {
        // Default values
        let duration = 1;
        let delay = 0;
        let ease = "power3.out";
        let stagger = '0.1';
        let screenTrigger = 75; // % of the screen
        let markers = false;

        for (let currentElement of downElements) {
            // A) Override values
            duration = currentElement.hasAttribute("data-gsap-duration")
                ? currentElement.getAttribute("data-gsap-duration")
                : duration;

            delay = currentElement.hasAttribute("data-gsap-delay")
                ? currentElement.getAttribute("data-gsap-delay")
                : delay;

            ease = currentElement.hasAttribute("data-gsap-ease")
                ? currentElement.getAttribute("data-gsap-ease")
                : ease;

            screenTrigger = currentElement.hasAttribute("data-gsap-screenTrigger")
                ? currentElement.getAttribute("data-gsap-screenTrigger")
                : screenTrigger;

            markers = currentElement.hasAttribute("data-gsap-markers") ? true : markers;

            // Configure stagger
            let animElement = currentElement;
            let offset = currentElement.offsetHeight; // We need to move the trigger to compensate the from offset
            if (currentElement.hasAttribute("data-gsap-stagger")) {
                stagger = (currentElement.getAttribute("data-gsap-stagger") != "") ? currentElement.getAttribute("data-gsap-stagger") : 0.1;
                let staggerSelector = currentElement.hasAttribute("data-gsap-staggerSelector") ? currentElement.getAttribute("data-gsap-staggerSelector") : 'div';
                animElement = currentElement.querySelectorAll(':scope > ' + staggerSelector);
                offset = 0;
            }

            // B) Set elements to starting values
            gsap.set(animElement, {
                y: "-100%"
            });

            // C) => Assign effect
            gsap.to(animElement, {
                autoAlpha: 1,
                y: 0,
                delay: delay,
                duration: duration,
                ease: ease,
                stagger: stagger,
                scrollTrigger: {
                    trigger: currentElement,
                    start: "top+=" + offset + " top+=" + screenTrigger + "%",
                    markers: markers
                }
            });
        }
    }

    // FADE-DOWN
    let fadeDownElements = document.querySelectorAll('[data-gsap="fadeDown"]');
    if (fadeDownElements.length) {
        // Default values
        let duration = 1;
        let delay = 0;
        let ease = "power3.out";
        let stagger = '0.1';
        let screenTrigger = 75; // % of the screen
        let markers = false;

        for (let currentElement of fadeDownElements) {
            // A) Override values
            duration = currentElement.hasAttribute("data-gsap-duration")
                ? currentElement.getAttribute("data-gsap-duration")
                : duration;

            delay = currentElement.hasAttribute("data-gsap-delay")
                ? currentElement.getAttribute("data-gsap-delay")
                : delay;

            ease = currentElement.hasAttribute("data-gsap-ease")
                ? currentElement.getAttribute("data-gsap-ease")
                : ease;

            screenTrigger = currentElement.hasAttribute("data-gsap-screenTrigger")
                ? currentElement.getAttribute("data-gsap-screenTrigger")
                : screenTrigger;

            markers = currentElement.hasAttribute("data-gsap-markers") ? true : markers;

            // Configure stagger
            let animElement = currentElement;
            let offset = currentElement.offsetHeight; // We need to move the trigger to compensate the from offset
            if (currentElement.hasAttribute("data-gsap-stagger")) {
                stagger = (currentElement.getAttribute("data-gsap-stagger") != "") ? currentElement.getAttribute("data-gsap-stagger") : 0.1;
                let staggerSelector = currentElement.hasAttribute("data-gsap-staggerSelector") ? currentElement.getAttribute("data-gsap-staggerSelector") : 'div';
                animElement = currentElement.querySelectorAll(':scope > ' + staggerSelector);
                offset = 0;
            }

            // B) Set elements to starting values
            gsap.set(animElement, {
                y: "-100%",
                autoAlpha: 0
            });

            // C) => Assign effect
            gsap.to(animElement, {
                autoAlpha: 1,
                y: 0,
                delay: delay,
                duration: duration,
                ease: ease,
                stagger: stagger,
                scrollTrigger: {
                    trigger: currentElement,
                    start: "top+=" + offset + " top+=" + screenTrigger + "%",
                    markers: markers
                }
            });
        }
    }

    // FADE-IN
    let fadeInElements = document.querySelectorAll('[data-gsap="fadeIn"]');
    if (fadeInElements.length) {
        // Default values
        let duration = 1;
        let delay = 0;
        let ease = "power3.out";
        let stagger = '0.1';
        let screenTrigger = 75; // % of the screen
        let markers = false;

        for (let currentElement of fadeInElements) {
            // A) Override values
            duration = currentElement.hasAttribute("data-gsap-duration")
                ? currentElement.getAttribute("data-gsap-duration")
                : duration;

            delay = currentElement.hasAttribute("data-gsap-delay")
                ? currentElement.getAttribute("data-gsap-delay")
                : delay;

            ease = currentElement.hasAttribute("data-gsap-ease")
                ? currentElement.getAttribute("data-gsap-ease")
                : ease;

            screenTrigger = currentElement.hasAttribute("data-gsap-screenTrigger")
                ? currentElement.getAttribute("data-gsap-screenTrigger")
                : screenTrigger;

            markers = currentElement.hasAttribute("data-gsap-markers") ? true : markers;

            // Configure stagger
            let animElement = currentElement;
            if (currentElement.hasAttribute("data-gsap-stagger")) {
                stagger = (currentElement.getAttribute("data-gsap-stagger") != "") ? currentElement.getAttribute("data-gsap-stagger") : 0.1;
                let staggerSelector = currentElement.hasAttribute("data-gsap-staggerSelector") ? currentElement.getAttribute("data-gsap-staggerSelector") : 'div';
                animElement = currentElement.querySelectorAll(':scope > ' + staggerSelector);
            }

            // B) Set elements to starting values
            gsap.set(animElement, {
                autoAlpha: 0,
            });

            // C) => Assign effect
            gsap.to(animElement, {
                autoAlpha: 1,
                delay: delay,
                duration: duration,
                ease: ease,
                stagger: stagger,
                scrollTrigger: {
                    trigger: currentElement,
                    start: "top top+=" + screenTrigger + "%",
                    markers: markers
                }
            });
        }
    }

    // FADE-UP
    let fadeUpElements = document.querySelectorAll('[data-gsap="fadeUp"]');
    if (fadeUpElements.length) {
        // Default values
        let duration = 1;
        let delay = 0;
        let ease = "power3.out";
        let stagger = '0.1';
        let screenTrigger = 75; // % of the screen
        let markers = false;

        for (let currentElement of fadeUpElements) {
            // A) Override values
            duration = currentElement.hasAttribute("data-gsap-duration")
                ? currentElement.getAttribute("data-gsap-duration") 
                : duration;

            ease = currentElement.hasAttribute("data-gsap-delay")
                ? currentElement.getAttribute("data-gsap-delay")
                : ease;

            ease = currentElement.hasAttribute("data-gsap-ease")
                ? currentElement.getAttribute("data-gsap-ease")
                : ease;

            screenTrigger = currentElement.hasAttribute("data-gsap-screenTrigger")
                ? currentElement.getAttribute("data-gsap-screenTrigger")
                : screenTrigger;

            markers = currentElement.hasAttribute("data-gsap-markers") ? true : markers;

            // Configure stagger
            let animElement = currentElement;
            let offset = currentElement.offsetHeight; // We need to move the trigger to compensate the from offset
            if (currentElement.hasAttribute("data-gsap-stagger")) {
                stagger = (currentElement.getAttribute("data-gsap-stagger") != "") ? currentElement.getAttribute("data-gsap-stagger") : 0.1;
                let staggerSelector = currentElement.hasAttribute("data-gsap-staggerSelector") ? currentElement.getAttribute("data-gsap-staggerSelector") : 'div';
                animElement = currentElement.querySelectorAll(':scope > ' + staggerSelector);
                offset = 0;
            }

            // B) Set elements to starting values
            gsap.set(animElement, {
                y: "100%",
                autoAlpha: 0
            });

            // C) => Assign effect
            gsap.to(animElement, {
                autoAlpha: 1,
                y: 0,
                delay: delay,
                duration: duration,
                ease: ease,
                stagger: stagger,
                scrollTrigger: {
                    trigger: currentElement,
                    start: "top-=" + offset + " top+=" + screenTrigger + "%",
                    markers: markers
                }
            });
        }
    }

    // SCROLL-TO
    let scrollToElements = document.querySelectorAll('[data-gsap-scroll]');
    if (scrollToElements.length) {
        // Default values
        let duration = 1;
        let delay = 0;
        let ease = "power3.out";
        let offsetY = 0;
        let autokill = true;

        for (let currentElement of scrollToElements) {
            // A) Override values
            duration = currentElement.hasAttribute("data-gsap-duration")
                ? currentElement.getAttribute("data-gsap-duration")
                : duration;

            delay = currentElement.hasAttribute("data-gsap-delay")
                ? currentElement.getAttribute("data-gsap-delay")
                : delay;

            ease = currentElement.hasAttribute("data-gsap-ease")
                ? currentElement.getAttribute("data-gsap-ease")
                : ease;
            
            offsetY = currentElement.hasAttribute("data-gsap-offsetY")
                ? currentElement.getAttribute("data-gsap-offsetY")
                : offsetY;

            autokill = currentElement.hasAttribute("data-gsap-force") ? false : autokill;

            // B) Set elements to starting values
            // Nothing to see here...

            // C) => Assign effect
            let target = document.querySelector(currentElement.getAttribute("data-gsap-scroll"));
            if (target) {
                currentElement.addEventListener('click', () =>{
                    gsap.to(window, {
                        duration: duration, 
                        delay: delay, 
                        ease: ease, 
                        scrollTo: {
                            y: target,
                            offsetY: offsetY,
                            autoKill: autokill,
                        },
                    });
                });
            } else {
                console.log("ScrollTo: Target " + currentElement.getAttribute("data-gsap-scroll") + " is null.");
            }
        }
    }

    // SECTION PARALLAX
    let sectionParallaxElements = document.querySelectorAll('[data-gsap="sectionParallax"]');
    if (sectionParallaxElements.length) {
        // Default values
        let scrub = 0.5;
        let parallaxEm = 25; // em to move up for parallax effect
        let markers = false;
    
        for (let currentElement of sectionParallaxElements) {
            // A) Override values
            scrub = currentElement.hasAttribute("data-gsap-scrub")
                ? currentElement.getAttribute("data-gsap-scrub")
                : scrub;
    
            parallaxEm = currentElement.hasAttribute("data-gsap-parallaxEm")
                ? currentElement.getAttribute("data-gsap-parallaxEm")
                : parallaxEm;
    
            markers = currentElement.hasAttribute("data-gsap-markers") ? true : markers;
            
            // B) Set elements to starting values
            // Nothing to see here...

            // C) => Assign effect
            gsap.to(currentElement, {
                y: -Math.abs(parallaxEm) + "em",
                ease: "none",
                scrollTrigger: {
                    trigger: currentElement,
                    start: "top bottom",
                    end: "top top",
                    scrub: scrub,
                    markers: markers
                }
            });
        }
    }

    // UP
    let upElements = document.querySelectorAll('[data-gsap="up"]');
    if (upElements.length) {
        // Default values
        let duration = 1;
        let delay = 0;
        let ease = "power3.out";
        let stagger = '0.1';
        let screenTrigger = 75; // % of the screen
        let markers = false;

        for (let currentElement of upElements) {
            // A) Override values
            duration = currentElement.hasAttribute("data-gsap-duration")
                ? currentElement.getAttribute("data-gsap-duration") 
                : duration;

            ease = currentElement.hasAttribute("data-gsap-delay")
                ? currentElement.getAttribute("data-gsap-delay")
                : ease;

            ease = currentElement.hasAttribute("data-gsap-ease")
                ? currentElement.getAttribute("data-gsap-ease")
                : ease;

            screenTrigger = currentElement.hasAttribute("data-gsap-screenTrigger")
                ? currentElement.getAttribute("data-gsap-screenTrigger")
                : screenTrigger;

            markers = currentElement.hasAttribute("data-gsap-markers") ? true : markers;

            // Configure stagger
            let animElement = currentElement;
            let offset = currentElement.offsetHeight; // We need to move the trigger to compensate the from offset
            if (currentElement.hasAttribute("data-gsap-stagger")) {
                stagger = (currentElement.getAttribute("data-gsap-stagger") != "") ? currentElement.getAttribute("data-gsap-stagger") : 0.1;
                let staggerSelector = currentElement.hasAttribute("data-gsap-staggerSelector") ? currentElement.getAttribute("data-gsap-staggerSelector") : 'div';
                animElement = currentElement.querySelectorAll(':scope > ' + staggerSelector);
                offset = 0;
            }

            // B) Set elements to starting values
            gsap.set(animElement, {
                y: "100%"
            });

            // C) => Assign effect
            gsap.to(animElement, {
                autoAlpha: 1,
                y: 0,
                delay: delay,
                duration: duration,
                ease: ease,
                stagger: stagger,
                scrollTrigger: {
                    trigger: currentElement,
                    start: "top-=" + offset + " top+=" + screenTrigger + "%",
                    markers: markers
                }
            });
        }
    }
    
};

/* [LIBRARY STRUCTURE]
    // ANIMATION_NAME
    let xxxxx-Elements = document.querySelectorAll('[data-gsap="xxxxx"]');
    if (xxxxx.length) {
        // Default values
        let duration = 1;
        let delay = 0;
        let ease = "power3.out";
        let screenTrigger = 75; // % of the screen
        let markers = false;

        for (let currentElement of xxxElements) {
            // A) Override values
            duration = currentElement.hasAttribute("data-gsap-duration")
                ? currentElement.getAttribute("data-gsap-duration")
                : duration;

            delay = currentElement.hasAttribute("data-gsap-delay")
                ? currentElement.getAttribute("data-gsap-delay")
                : delay;

            ease = currentElement.hasAttribute("data-gsap-ease")
                ? currentElement.getAttribute("data-gsap-ease")
                : ease;

            screenTrigger = currentElement.hasAttribute("data-gsap-screenTrigger")
                ? currentElement.getAttribute("data-gsap-screenTrigger")
                : screenTrigger;

            markers = currentElement.hasAttribute("data-gsap-markers") ? true : markers;

            let animElement = currentElement; // just in case it's not the final element to animate (i.e if we work on a stagger container)

            // B) Set elements to starting values
            gsap.set(animElement, {
                /////
            });

            // C) => Assign effect
            gsap.to(animElement, {
                duration: duration, 
                delay: delay,
                easer: ease, 
                screenTrigger: {
                    ///
                    start: "top top+=" + screenTrigger + "%",
                }
            });
        }
    }
*/